import { connect } from 'react-redux'
import DetailView from '../../../components/Sections/Propiedades/Detail'
import { loadProperty, setInfoType, loadRelatedProperties, setStreetViewStatus } from '../../../actions/propiedades'
import { setPanelProfile } from '../../../actions/header'
import { retriveCategories } from '../../../actions/office'
import { retriveLandUses } from '../../../actions/terrains'
import { retriveUbications } from '../../../actions/residential'


const mapStateToProps = (state) => {
  return {
    property: state.propiedades.detail,
    showModal: state.propiedades.showModal,
    infoType: state.propiedades.infoType,
    loading: state.propiedades.loadingDetail,
    related: state.propiedades.related,
    neighborhoodDetail: state.propiedades.neighborhoodDetail,
    officeCategories: state.office.categories,
    terrainUses: state.terrains.uses,
    siblings: state.propiedades.siblings,
    ubications: state.residential.ubications,
    streetView: state.propiedades.streetView,
    originPath: state.searchBar.originPath,
    originOffice: state.searchBar.originOffice,
    phone: state.header.telephone
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    checkStreetViewStatus: (value) => dispatch(setStreetViewStatus(value)),
    onChangePanelProfile: () => dispatch(setPanelProfile()),
    onChangeInfoType: value => dispatch(setInfoType(value)),
    loadPropertyDetails: value => {
      dispatch(loadProperty(value))
      dispatch(loadRelatedProperties(value))
    },
    findCategories: () => dispatch(retriveCategories()),
    findterrainUses: () => dispatch(retriveLandUses()),
    findUbications: () => dispatch(retriveUbications())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailView)



// WEBPACK FOOTER //
// ./src/containers/Sections/Propiedades/detail.js